import React from 'react';
import { useIntl } from 'react-intl';
import { SubCategory } from './CategoryCard';

interface SubCategoryCardProps {
  subCategory: SubCategory;
  onOrder: (url: string) => void;
  onLearnMore: (url?: string) => void;
}

const SubCategoryCard: React.FC<SubCategoryCardProps> = ({
  subCategory,
  onOrder,
  onLearnMore
}) => {
  const intl = useIntl();
  return (
    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
      <div className="card h-100 shadow-sm">
        <div className="card-body d-flex flex-column">
          {/* Icône */}
          <div className="symbol symbol-50px mb-4 d-flex justify-content-center">
            <span className="symbol-label">
              <i className={`${subCategory.icon} fs-2x text-${subCategory.iconBg}`}></i>
            </span>
          </div>

          {/* Titre */}
          <h3 className="card-title fw-bold fs-4 mb-3 text-center">
            {subCategory.title}
          </h3>

          {/* Description */}
          <p className="card-text text-gray-600 mb-3 flex-grow-1">
            {subCategory.description}
          </p>

          {/* Tarif */}
          <div className="text-center mb-4">
            <span className="badge badge-light-primary fs-5 fw-bold">
              {subCategory.tarif}
            </span>
          </div>

          {/* Boutons */}
          <div className="d-flex flex-column gap-2">
            <button
              className={`btn btn-${subCategory.iconBg} btn-sm`}
              onClick={() => onOrder(subCategory.urlCommande)}
              disabled={!subCategory.isActive}
            >
              <i className="fa-solid fa-cart-shopping me-2" style={{color: 'white'}}></i>
              {intl.formatMessage({id: 'COMMON.ORDER_NOW'})}
            </button>

            {subCategory.urlEnSavoirPlus && (
              <button
                className="btn btn-light-primary btn-sm"
                onClick={() => onLearnMore(subCategory.urlEnSavoirPlus)}
              >
                <i className="fa-solid fa-circle-info me-2"></i>
                {intl.formatMessage({id: 'COMMON.LEARN_MORE'})}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubCategoryCard;
